import React from 'react';
import {IProduct} from 'data/interfaces/products';
import VoucherSellerComments from './components/voucherSellerComments';
import VoucherConditionComments from './components/voucherConditionComments';
import VoucherInfo from "./components/voucherDetailsCard/components/voucherInfo";
import PlaceDetailsCard from '../../../commons/placeDetailsCard';
import PlaceReviewsCard from '../../../commons/placeReviewsCard';
import PlaceLocationCard from '../../../commons/placeLocationCard';

interface IFirstPageProps {
  product?: IProduct;
}

const FirstStage = (props: IFirstPageProps) => (
  <>
    <VoucherSellerComments product={props.product}/>
    <VoucherConditionComments product={props.product}/>
    <PlaceDetailsCard infoComponent={VoucherInfo}
                      mobileTitle={"פרטי שובר"}
                      toolTip="שובר"
                      product={props.product}
    />
    <PlaceLocationCard product={props.product}/>
    <PlaceReviewsCard product={props.product} initialReviewsShown={3} disableLoadMore={true}/>
  </>
);

FirstStage.defaultProps = {};

export default React.memo(FirstStage);
